import { useSession } from '../auth/AuthProvider'
import { AuthCard } from './AuthCard'

export const NO_ACCESS_TITLE = "You don't have access to this site."
export const IMPERSONATION_ENDED_TITLE = 'This impersonation has ended. Start again from the admin site.'

/**
 * No access (UserFlows A-01, Frontend §5.2): signed in, but not allowed on this site. In the clinic app a super
 * admin without an impersonation also gets a link to the admin site (D-40).
 */
export function NoAccessPage({
  siteName,
  adminSiteUrl,
  impersonationEnded = false,
}: {
  siteName: string
  adminSiteUrl?: string | undefined
  /** The clinic app's impersonation ended before it opened (Frontend §6.4 step 3). */
  impersonationEnded?: boolean
}) {
  const session = useSession()
  if (impersonationEnded) {
    return (
      <AuthCard siteName={siteName}>
        <h1>{IMPERSONATION_ENDED_TITLE}</h1>
        {adminSiteUrl && (
          <p className="muted">
            <a href={adminSiteUrl}>Open the admin site</a>
          </p>
        )}
        <button type="button" className="btn btn-secondary btn-block" onClick={() => void session.signOut()}>
          Sign out
        </button>
      </AuthCard>
    )
  }
  return (
    <AuthCard siteName={siteName}>
      <h1>{NO_ACCESS_TITLE}</h1>
      {adminSiteUrl && (
        <p className="muted">
          Super admins open clinics from the admin site. <a href={adminSiteUrl}>Open the admin site</a>
        </p>
      )}
      <button type="button" className="btn btn-secondary btn-block" onClick={() => void session.signOut()}>
        Sign out
      </button>
    </AuthCard>
  )
}
